import styled from "styled-components";

/**
 * Wrapper principal do FlightsFilterWrapper.
 */
export const FlightsFilterWrapper = styled.div.withConfig({})<{}>`
  display: flex;
  flex-direction: column;
  width: 100vw;
  /* overflow-y: auto; */
`;

export const StopsFilterWrapper2 = styled.div.withConfig({})<{}>`
  display: flex;
  flex-direction: column;
  width: 100vw;
  overflow-y: auto;
`;
